import { useEffect, useState, useRef } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import { Button } from "@vds/buttons";
import "@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css";
import {
  fetchShipment,
  mapboxOwner,
  terrainId,
  satelliteId,
} from "../../../configuration";
import ToastNotification from "../../../global/components/ToastNotification";
import mapboxgl from "mapbox-gl";
import DeleteShipmentModal from "./DeleteModel";
import ShipmentPopup from "./ShipmentsDetailsModel";
import AlertsContent from "./AlertsContent";
import { getRandomUUID } from "../../../Token";
import ShipmentData from "./ShipmentData";
import { useDispatch, useSelector } from "react-redux";
import {
  updateUI,
  singleDeleteRequest,
  fetchAlertsContentRequest,
  fetchProfileRequest,
  fetchDeviceRequest,
  fetchDeviceNameRequest,
  setActiveTabGlobal,
  setShipmentDataGlobal,
  setShipmentStatusGlobal,
  fetchLocationAlertsAction,
  setTrackDataLoaded,
} from "../../../store/actions/shipment";
import { fetchRequest as fetchDeviceProfile,updateUI as updateshipUI,fetchDeviceTypeRequest } from "../../../store/actions/deviceProfile";
import { fetchRequest as fetchLocationRequest } from "../../../store/actions/location";
import EditShipment from "../EditandClone";
import { fetchRequest } from "../../../store/actions/alertsShipment";
import getAddressfromLatLong from "../../../global/utility/getAddressfromLatLong";
import ShipmentFields from "./ShipmentFields";
import dayjs from "dayjs";
import { Flex, Spin, Tag } from "antd";
import {
  returnPopups,
  popUpAndIndicator,
  addAccuracyCircle,
} from "../../../global/utility/Utils";
import { fetchLocationAlertsSuccess } from "../../../store/actions/shipment";
import { IconButton } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { addButtons } from "./map-utils";
import ShipmentDropdownSingleFields from "../ShipmentDropdownSingleFields";
import CloneShipment from "../Clone";
import UpdateStateShipment from "../UpdateStateShipment";
import CancelStateShipment from "../CancelStateShipment";
import CreateDeviceProfile from "../../DeviceProfile/CreateDeviceProfile";
import CreateNewLocation from "../../LocationDetails/CreateLocation/new";
import getSingleDeviceProfile from "../../DeviceProfile/utility/getSingleDeviceProfile";
import {
  updateUI as updateDeviceProfileUI,
} from "../../../store/actions/deviceProfile";
import ValidateDeviceProfileModal from "../../DeviceProfile/ValidateDeviceProfileModal"
import {
  updateUI as updateLocationUI,
} from "../../../store/actions/location";

const ViewShipment = () => {
  const dispatch = useDispatch();
  const {
    isEditShipmentOpen,
    singleDeleteShipConfirmed,
    notification,
    isCloneOpen,
    shouldUpdateDeviceProfile,
    deviceTypes,
    deviceProfiles,
    forms
  } = useSelector((state) => ({
    isEditShipmentOpen: state.shipment.ui.editShipment.isEditShipment,
    singleDeleteShipConfirmed: state.shipment.ui.delete.singleDelete,
    notification: state.shipment.ui.notification,
    isCloneOpen: state.shipment.ui.clone.isClone,
    shouldUpdateDeviceProfile: state.deviceProfile.shouldUpdate,
    deviceTypes: state.deviceProfile.ui.form.deviceTypes,
    deviceProfiles: state.deviceProfile.data.devices,
    forms: state.deviceProfile.ui.form,
  }));
  const shipProfileList = useSelector(
    (state) => state?.shipment?.data?.shipProfile
  );
  const { locationForm, formFields, form,hasActiveShipments,hasActiveShipments1 } = useSelector((state) => ({
    locationForm: state?.location?.ui?.form,
    form: state.deviceProfile.ui.form,
    formFields: state.deviceProfile.ui.form.fields,
     hasActiveShipments:state.deviceProfile.ui,
      hasActiveShipments1:state.deviceProfile.ui.shipValidate
  }));

  //Declaration
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = location;
  const mapContainer = useRef(null);
  const map = useRef(null);
  const intervalRef = useRef(null);
  const correctShipmentLoaded = useRef(false);
  const markRef = useRef(null);
  const viewShipmentLoaded = useRef(false);
  const [startDateTime, setStartDateTime] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [selectedOption, setSelectedOption] = useState("now");
  const [showDeleteOrg, setShowDeleteShip] = useState(false);
  const [activeTab, setActiveTab] = useState(state?.alert || "map");
  const [shipmentData, setShipmentData] = useState(null);
  const [currentCoordinates, setCurrentCoordinates] = useState([0, 0]);
  const [intermediateLocations, setIntermediateLocations] = useState([]);
  const [shipmentid, setShipmentid] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const currentIndxRef = useRef(0);
  const [currentIndex, setCurrentIndex] = useState(currentIndxRef.current);
  const [pointsNo, setPointsNo] = useState(0);
  const [solidLinePoints, setSolidLinePoinnts] = useState([]);
  const filters = useSelector((state) => state.alertsShipment.filters);
  const shouldUpdate = useSelector((state) => state.shipment.shouldUpdate);
  const latlongVal = useSelector((state) => state.shipment.ui.location);
  const [bounds, setBounds] = useState([]);
  const activeTabGlobal = useSelector(
    (state) => state.shipment.activeTabGlobal
  );
  const pathPoints = useSelector((state) => state.shipment.shipmentTrackData);
  const trackDataLoaded = useSelector(
    (state) => state.shipment.trackDataLoaded
  );
  const selectedShipmentG = useSelector((state) => state.shipment.shipmentData);
  const fullScreenContainer = useRef();
  const [intermediateIndicators, setIntermediateIndicators] = useState([]);
  const [dynamicFeatureData, setDynamicFeatureData] = useState([]);
  const [destIndicatorReturned, setDestIndicatorReturned] = useState(null);
  const [rerender, setRerender] = useState(false);
  const [addressCurrentLoc, setAddress] = useState("");

  useEffect(() => {
    currentIndxRef.current = currentIndex;
  }, [currentIndex]);

  useEffect(() => {
    if (notification && notification.isActive) {
      setShowNotification(true);
      setNotificationProps({
        type: notification.type,
        message: notification.message,
        description: notification.description,
        style: notification.style,
      });

      const timer = setTimeout(() => {
        setShowNotification(false);
        dispatch(
          updateUI({
            key: "notification",
            value: {
              isActive: false,
              type: "success",
              message: "",
              description: "",
              style: { backgroundColor: "#d4edda", color: "#155724" },
            },
          })
        );
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [notification, dispatch]);

  useEffect(() => {
    if (shouldUpdateDeviceProfile) {
      dispatch(fetchDeviceProfile({ noLimit: true }));
      dispatch(
        updateDeviceProfileUI({
          key: "shouldUpdate",
          value: false,
        })
      );
    }
  }, [shouldUpdateDeviceProfile, dispatch]);

  useEffect(() => {
    if (!shipmentData?.deviceprofile?.id) return;
    const updated = shipProfileList?.find(
      (p) => p.profileid === shipmentData.deviceprofile.id
    );
    if (!updated) return;
    const newName =
      updated.profilename || updated.name || shipmentData.deviceprofile.profilename || shipmentData.deviceprofile.name;
    const prevName =
      shipmentData.deviceprofile.profilename || shipmentData.deviceprofile.name;
    if (newName && newName !== prevName) {
      setShipmentData((prev) => ({
        ...prev,
        deviceprofile: {
          ...prev.deviceprofile,
          profilename: updated.profilename ?? prev.deviceprofile.profilename,
          name: updated.name ?? prev.deviceprofile.name,
        },
      }));
    }
  }, [shipProfileList, shipmentData?.deviceprofile?.id]);


  useEffect(() => {
    if (activeTabGlobal) {
      setActiveTab(activeTabGlobal);
    }
    return () => {
      dispatch(setActiveTabGlobal({ activeTabGlobal: null }));
    };
  }, [activeTabGlobal]);

  useEffect(() => setPointsNo(pathPoints?.length - 1), [pathPoints]);
  useEffect(() => {
    return () => {
      dispatch(setTrackDataLoaded());
      dispatch(fetchLocationAlertsSuccess([]));
    };
  }, []);

  useEffect(() => {
    if (!isEditShipmentOpen && shipmentData?.shipmentid) {
      if (viewShipmentLoaded.current !== shipmentData.shipmentid) {
        fetchCompleteShipmentData(
          // shipmentData?.shipmentname,
          id
        );
        viewShipmentLoaded.current = shipmentData.shipmentid; // Update ref after fetching
      }
    }
  }, [shouldUpdate, isEditShipmentOpen]);

  const validateCoord = (coord) => {
    if (coord && Array.isArray(coord) && coord.length > 1) {
      if (!isNaN(coord[0]) && !isNaN(coord[1])) {
        if (
          coord[0] >= -180 &&
          coord[0] <= 180 &&
          coord[1] >= -90 &&
          coord[1] <= 90
        ) {
          return true;
        }
        return false;
      }
      return false;
    } else {
      return false;
    }
  };

  async function plotPath(indx) {
    if (!map.current || !pathPoints || pathPoints?.length === 0) return;
    const sliceIndx = indx;
    if (Array.isArray(pathPoints) && sliceIndx < pathPoints?.length) {
      let point = "";
      // if (sliceIndx == 0) {
        point = pathPoints[sliceIndx];
      // } else {
      //   point = pathPoints[sliceIndx - 1];
      // }

      if (
        Object.hasOwn(point, "coords") &&
        point?.coords.length > 1 &&
        validateCoord(point?.coords)
      ) {
        map.current.setZoom(15);
        map.current.panTo(point?.coords);
        const locationDetails = await getAddressfromLatLong(
          point?.coords[1] || 40.72960781069406,
          point?.coords[0] || -74.53343516808366
        );
        setAddress(locationDetails);

        //accuracy circle
        //addAccuracyCircle(pathPoints[nextIndx], metricData?.accuracy);
        //Extend the solid line
        const updatedPoints = solidLinePoints?.slice(0, sliceIndx + 1);
        if (map.current.getSource("LineString-sourcel")) {
          map.current.getSource("LineString-sourcel").setData({
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [...updatedPoints],
            },
            properties: {},
          });
        }

        //Adds circles dynamically
        const dynamicData = {
          type: "FeatureCollection",
          features: [],
        };
        dynamicData.features = dynamicFeatureData?.slice(0, sliceIndx + 1);
        if (map.current.getSource("dynamic-circles")) {
          map.current.getSource("dynamic-circles").setData(dynamicData);
        }
        dispatch(
          updateUI({
            key: "location",
            value: {
              coordinates: point?.coords,
              locationdetails: locationDetails,
              datatimestamp: point?.timestamp,
              temperature: point?.temperature,
              battery: point?.battery,
              type: point?.type,
            },
          })
        );
      }
    }
  }

  useEffect(() => {
    if (!pathPoints || pathPoints?.length == 0) return;
    if (Array.isArray(pathPoints) && pathPoints?.length > 0) {
      //setRangeValue(currentIndex);
      plotPath(currentIndex);
    }
  }, [currentIndex]);

  useEffect(() => {
    setShipmentData(selectedShipmentG);
  }, [selectedShipmentG]);

  useEffect(() => {
    //shipment data initialization from location props
    const shipmentData = location?.state?.shipmentData;
    if (!shipmentData) return;

    const intermediateLocations =
      shipmentData?.deviceprofile?.locations?.filter(
        (loc) =>
          !loc?.locationtype?.includes("Destination") &&
          !loc?.locationtype?.includes("Origin")
      );

    setIntermediateLocations(
      intermediateLocations ? intermediateLocations : [0, 0]
    );

    setShipmentData({
      ...shipmentData,
      originLocation: shipmentData?.deviceprofile?.locations?.find(
        (loc) => loc.locationtype === "Origin"
      ),
      destinationLocation: shipmentData?.deviceprofile?.locations?.find(
        (loc) => loc.locationtype === "Destination"
      ),
      intermediateLocations: intermediateLocations,
    });
  }, [location.state]);

  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          if (prevIndex < pointsNo) {
            return prevIndex + 1;
          } else {
            clearInterval(intervalRef.current);
            setIsPlaying(false);
            return prevIndex;
          }
        });
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPlaying]);

  useEffect(() => {
    if (!shipmentData) return;

    const getData = async () => {
      if (!shipmentData?.createdon) return;
      try {
        let value = {
          startTime: shipmentData?.createdon,
          endTime: shipmentData?.updatedat,
          deviceId: shipmentData?.deviceid,
          shipmentId: shipmentData?.shipmentid,
          originCoord: [
            shipmentData?.originLocation?.longitude || 0,
            shipmentData?.originLocation?.latitude || 0,
          ],
          alertType: shipmentData?.originLocation?.alerttype || "No Alert",
        };
        dispatch(fetchLocationAlertsAction(value));
      } catch (error) {}
    };
    if (shipmentData && correctShipmentLoaded.current) {
      dispatch(
        fetchAlertsContentRequest({
          deviceid: shipmentData.deviceid,
          shipmentid: shipmentData.shipmentid,
          onComplete: () => getData(),
        })
      );
      dispatch(fetchProfileRequest());
      dispatch(fetchDeviceProfile({ noLimit: true }));
      //return;
    }
  }, [shipmentData, dispatch, shouldUpdateDeviceProfile]);

  const handleStartClick = (play) => {
    if (!pathPoints || pathPoints?.length == 0) return;
    // handles play/pause
    if (play) {
      if (currentIndex == pointsNo) {
        setCurrentIndex(0);
        //setInitial(2);
      }
      setIsPlaying(true);
      //setDisablebtn(false)
    } else {
      setIsPlaying(false);
    }
  };

  const handleRangeChange = (e) => {
    const newValue = parseInt(e.target.value);
    clearTimeout(window.rangeChangeTimeout);
    window.rangeChangeTimeout = setTimeout(() => {
      setCurrentIndex(newValue);
    }, 100);
  };

  const handleForwardClick = () => {
    if (currentIndex < pointsNo) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleBackwardClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setRerender(!rerender);
    }, 1000);
    return () => clearTimeout(timer);
  }, [currentCoordinates, pathPoints, shipmentData, activeTab]);

  useEffect(() => {
    const currIndx = currentIndex;
    if (currIndx > 0) {
      setCurrentIndex(currIndx - 1);
      setTimeout(() => setCurrentIndex(currIndx), 2000);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!shipmentData || !trackDataLoaded) return;

    const originCoordinates = [
      shipmentData?.originLocation?.longitude || 0,
      shipmentData?.originLocation?.latitude || 0,
    ];
    const destinationCoordinates = [
      shipmentData?.destinationLocation?.longitude || 0,
      shipmentData?.destinationLocation?.latitude || 0,
    ];

    const nav = new mapboxgl.NavigationControl({
      visualizePitch: true,
      showCompass: false,
    });
    if (activeTab !== "map") return;
    if (!mapboxgl.supported()) {
      console.error("WebGL is not supported in this browser. Map cannot be initialized.");
      return;
    }
    try {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: `mapbox://styles/${mapboxOwner}/${terrainId}`,
        center: validateCoord(originCoordinates) ? originCoordinates : [0, 0],
        zoom: 9,
      });
    } catch (e) {
      console.error("Failed to initialize map:", e);
      return;
    }
    //map.current.addControl(new mapboxgl.FullscreenControl(), "top-left");
    map.current.addControl(nav, "bottom-right");

    //adds satellite and Terrain buttons
    addButtons(map.current, terrainId, satelliteId, mapboxOwner);

    if (!map?.current) return;
    setIsLoading(false);

    if (validateCoord(originCoordinates)) {
      const popupstr = returnPopups({
        loc_type: "Origin",
        Address: shipmentData?.originLocation?.address,
        locationName: shipmentData?.originLocation?.name,
      });
      const indicator = `<div class="shipment-map-indicator-container">
              <img src="/assets/map-Indicators.svg" style="width:20px; height:20px" alt="Start Marker"/>
        </div>`;
      popUpAndIndicator(originCoordinates, popupstr, indicator, map?.current);
      map.current.on("style.load", () => {
        addAccuracyCircle(originCoordinates, shipmentData?.originLocation?.radius, map?.current, [], 'origin');
      });
    }

    if (pathPoints && Array.isArray(pathPoints)) {
      // Map initial load
      map.current.on("load", async () => {
        let bounds = pathPoints?.reduce((bounds, point) => {
          return validateCoord(point) ? bounds.extend(point) : bounds;
        }, new mapboxgl.LngLatBounds());

        //extend bounds to origin coords and destination coords
        bounds = validateCoord(originCoordinates)
          ? bounds.extend(originCoordinates)
          : bounds;
        bounds = validateCoord(destinationCoordinates)
          ? bounds.extend(destinationCoordinates)
          : bounds;
        intermediateLocations?.forEach((loc) => {
          const coord = [loc?.longitude, loc?.latitude];
          bounds = validateCoord(coord) ? bounds.extend(coord) : bounds;
        });
        if (shipmentData?.shipmentstate?.toLowerCase() != "completed") {
          const currentLoc = [
            shipmentData?.currentlocation?.long,
            shipmentData?.currentlocation?.lat,
          ];
          bounds = validateCoord(currentLoc)
            ? bounds.extend(currentLoc)
            : bounds;
        }

        const sw = [bounds?._sw?.lng, bounds?._sw?.lat];
        const ne = [bounds?._ne?.lng, bounds?._ne?.lat];

        if (validateCoord(sw) && validateCoord(ne)) {
          map.current.fitBounds(bounds, { padding: 90 });
          setBounds(bounds);
        }

        // remove layers and source before adding
        if (map.current?.getLayer("LineStringLayer-layerl")) {
          map.current.removeLayer("LineStringLayer-layerl");
        }
        if (map.current?.getLayer("dotted-line-layerl")) {
          map.current.removeLayer("dotted-line-layerl");
        }
        if (map.current?.getLayer("dynamic-circles-id")) {
          map.current.removeLayer("dynamic-circles-id");
        }
        if (map.current?.getSource("LineString-sourcel")) {
          map.current.removeSource("LineString-sourcel");
        }
        if (map.current?.getSource("dotted-line-sourcel")) {
          map.current.removeSource("dotted-line-sourcel");
        }
        if (map.current?.getSource("dynamic-circles")) {
          map.current.removeSource("dynamic-circles");
        }

        if (pathPoints) {
          const dynFeatureData = [];
          const solidLinePts = [];
          let indx = 0;
          for (const ele of pathPoints) {
            if (validateCoord(ele.coords)) {
              const statusClass =
                ele?.alertSeverity == "No Alert"
                  ? "no-alert"
                  : ele?.alertSeverity?.toLowerCase() == "critical"
                  ? "critical"
                  : ele?.alertSeverity?.toLowerCase() == "major"
                  ? "warning"
                  : ele?.alertSeverity?.toLowerCase() == "minor"
                  ? "notification"
                  : ele?.alertSeverity;
              const status =
                ele?.alertSeverity?.toLowerCase() === "critical" ||
                ele?.alertSeverity?.toLowerCase() === "error"
                  ? "CRITICAL"
                  : ele?.alertSeverity?.toLowerCase() == "major" ||
                    ele?.alertSeverity?.toLowerCase() == "warning"
                  ? "WARNING"
                  : ele?.alertSeverity?.toLowerCase() == "minor" ||
                    ele?.alertSeverity?.toLowerCase() == "notification"
                  ? "NOTIFICATION"
                  : ele?.alertSeverity == "No Alert" ||
                    ele?.alertSeverity?.toLowerCase() == "no alert"
                  ? "OK"
                  : ele?.alertSeverity;
              solidLinePts.push(ele.coords);
              dynFeatureData.push({
                type: "Feature",
                id: indx,
                properties: {
                  status,
                  statusClass,
                  coordsForAddress: [ele.coords[1], ele.coords[0]],
                  timestamp: ele.timestamp,
                  strokeColor: "#000000",
                },
                geometry: {
                  type: "Point",
                  coordinates: ele.coords,
                },
              });
              setSolidLinePoinnts(solidLinePts);
              setDynamicFeatureData(dynFeatureData);
              indx++;
            }
          }
          plotPath(currentIndex);
        }

        //Draws solid line using location pts from eventsmanager/search api
        // const points = solidLinePoints?.filter((coord) => validateCoord(coord));
        map?.current?.addSource("LineString-sourcel", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: [],
                },
                properties: {},
              },
            ],
          },
        });

        map.current.addLayer({
          id: "LineStringLayer-layerl",
          type: "line",
          source: "LineString-sourcel",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#000000",
            "line-width": 2,
          },
        });

        // coloured circles which indicate location of shipment
        map.current.addSource("dynamic-circles", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [],
          },
        });

        map.current.addLayer({
          id: "dynamic-circles-id",
          type: "circle",
          source: "dynamic-circles",
          paint: {
            "circle-radius": 8,
            "circle-color": [
              "match",
              ["get", "status"],
              "CRITICAL",
              "#FF8027",
              "WARNING",
              "#FED60E",
              "NOTIFICATION",
              "#006FC1",
              "OK",
              "#00B845",
              "#926e83",
            ],
            "circle-stroke-color": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              "#ffffff",
              "#000000",
            ],
            "circle-stroke-width": 2,
          },
        });

        let isClicked = false;
        let isHover = false;
        let hoverid = "";
        const popup = new mapboxgl.Popup({
          closeButton: true,
          closeOnClick: false,
        }).addClassName("customPopupCurrMapClass");
        const showPopup = async (e) => {
          if (currentIndxRef.current == e.features[0].id) return;
          hoverid = e.features[0].id;
          map.current.setFeatureState(
            { source: "dynamic-circles", id: e.features[0].id },
            { hover: true }
          );
          map.current.getCanvas().style.cursor = "pointer";
          if (e.features.length > 0) {
            const feature = e.features[0];
            const address = await getAddressfromLatLong(
              ...JSON.parse(feature?.properties?.coordsForAddress)
            );
            popup
              ?.setLngLat(feature.geometry.coordinates)
              .setHTML(
                `<div class="custom-map-popup">${returnPopups({
                  status: feature?.properties?.status,
                  Address: address,
                  timestamp: feature?.properties?.timestamp,
                  statusClass: feature?.properties?.statusClass,
                })}</div>`
              )
              .addTo(map.current);
          }
        };

        popup.on("open", () => {
          document
            .getElementById("statusClickView")
            ?.addEventListener("click", (e) => {
              if (
                e?.target?.innerHTML?.trim() === "Ok" ||
                e?.target?.innerHTML?.trim() === "Completed"
              )
                return;
              if (e.target.id?.trim() === "statusClickView") {
                dispatch(setActiveTabGlobal({ activeTabGlobal: "dashboard" }));
                dispatch(setShipmentDataGlobal(shipmentData));
                dispatch(setShipmentStatusGlobal(e.target.innerHTML.trim()));
                navigate(`/viewshipment/${shipmentData?.shipmentid}`);
                return;
              }
            });
        });

        map.current.on("mouseenter", "dynamic-circles-id", (e) => {
          isHover = true;
          showPopup(e);
        });
        map.current.on("click", "dynamic-circles-id", (e) => {
          isHover = false;
          isClicked = true;
          showPopup(e);
        });
        map.current.on("mouseleave", "dynamic-circles-id", (e) => {
          map.current.getCanvas().style.cursor = "";
          if (!isClicked) {
            map.current.setFeatureState(
              { source: "dynamic-circles", id: hoverid },
              { hover: false }
            );
            popup.remove();
          }
        });
        popup.on("open", (e) => {
          if (!isHover) {
            isClicked = true;
          }
          map.current.setFeatureState(
            { source: "dynamic-circles", id: hoverid },
            { hover: true }
          );
        });
        popup.on("close", () => {
          isClicked = false;
          map.current.setFeatureState(
            { source: "dynamic-circles", id: hoverid },
            { hover: false }
          );
        });
      });
    }
  }, [rerender]);

  useEffect(() => {
    const startDate = new Date();
    const startDateTime = startDate.toISOString().slice(0, 16);
    setStartDateTime(startDateTime);
  }, [selectedOption]);

  useEffect(() => {
    if (!shipmentData || !trackDataLoaded || !map.current) return;
    if (
      !pathPoints ||
      (Array.isArray(pathPoints) && pathPoints?.length == 0) ||
      !currentIndex
    )
      return;

    const destinationCoordinates = [
      shipmentData?.destinationLocation?.longitude || 0,
      shipmentData?.destinationLocation?.latitude || 0,
    ];
    //plotting destination, currentloaction, dotted line
    const { coords, accuracy, alertSeverity, timestamp } =
      currentIndex > 0 ? pathPoints[currentIndex] : pathPoints[0];
    if (validateCoord(coords)) {
      //current location popup
      //if shipment is completed we should not show current location and dotted lines
      const currentLoc = coords;
      const statusClass =
        alertSeverity == "OK"
          ? "no-alert"
          : alertSeverity == "ERROR"
          ? "critical"
          : alertSeverity?.toLowerCase() == "major"
          ? "warning"
          : alertSeverity?.toLowerCase() == "minor"
          ? "notification"
          : alertSeverity;
      const status =
        alertSeverity === "No alert" ||
        alertSeverity === "No Alert" ||
        alertSeverity === "no alert" ||
        alertSeverity === "NO ALERT"
          ? "Ok"
          : alertSeverity === "ERROR" ||
            alertSeverity === "Error" ||
            alertSeverity === "error"
          ? "Critical"
          : alertSeverity?.toLowerCase() == "major"
          ? "Warning"
          : alertSeverity?.toLowerCase() == "minor"
          ? "Notification"
          : alertSeverity;

      if (markRef.current) {
        markRef.current.remove();
        markRef.current = null;
      }

      const popupstr = returnPopups({
        status,
        state: shipmentData?.shipmentstate,
        timestamp,
        Address: addressCurrentLoc,
        statusClass,
      });
      const indicator = `<img src="/assets/stateIndicator.svg" style="width:41px; height:60px; rotate: 294deg;" alt="Current Marker"/>`;
      const { popup, indicator: markerReturned } = popUpAndIndicator(
        currentLoc,
        popupstr,
        indicator,
        map?.current,
        "bottom"
      );
      markRef.current = markerReturned;

      if (
        !isPlaying &&
        currentIndex == pathPoints?.length - 1 &&
        shipmentData?.shipmentstate?.toLowerCase() == "completed"
      ) {
        if (markRef.current) {
          markRef.current.remove();
          markRef.current = null;
        }
        if (map?.current?.getLayer("haloRegionLayer")) {
          map.current.removeLayer("haloRegionLayer");
        }
        if (map?.current?.getLayer("haloRegion-outline")) {
          map.current.removeLayer("haloRegion-outline");
        }
        if (map?.current?.getSource("haloRegion")) {
          map.current.removeSource("haloRegion");
        }
      }

      popup.on("open", () => {
        document
          .getElementById("statusClickView")
          ?.addEventListener("click", (e) => {
            if (
              e?.target?.innerHTML?.trim() === "Ok" ||
              e?.target?.innerHTML?.trim() === "Completed"
            )
              return;
            if (e.target.id?.trim() === "statusClickView") {
              dispatch(setActiveTabGlobal({ activeTabGlobal: "dashboard" }));
              dispatch(setShipmentDataGlobal(shipmentData));
              dispatch(setShipmentStatusGlobal(e.target.innerHTML.trim()));
              navigate(`/viewshipment/${shipmentData?.shipmentid}`);
              return;
            }
          });
      });
      map.current.on("style.load", () => {
        addAccuracyCircle(coords, accuracy, map.current, bounds);
      });
    }

    //this condition represents plotting has been completed for shipment points
    if (!isPlaying && currentIndex == pathPoints?.length - 1) {
      //plotting intermediate locations
      for (let i = 0; i < intermediateLocations?.length; i++) {
        const loc = intermediateLocations[i];
        const coords = [loc?.longitude, loc?.latitude];
        if (validateCoord(coords)) {
          const popupstr = returnPopups({
            loc_type: loc?.locationtype,
            Address: loc?.address,
            locationName: loc?.name,
          });
          const indicator = `<div class="shipment-map-indicator-container">
                               <div style="width:15px; height:15px; background-color:white;
                               border-radius:50%; border:2px solid black;" alt="End Marker"/>
                           </div>`;
          const { indicator: indctr } = popUpAndIndicator(
            coords,
            popupstr,
            indicator,
            map?.current,
            "bottom"
          );
          setIntermediateIndicators([...intermediateIndicators, indctr]);
        }
      }
    } else {
      intermediateIndicators.forEach((indctr) => indctr.remove());
    }

    //add dotted line from current location to destination DOTTED LINE
    if (
      validateCoord(destinationCoordinates) &&
      validateCoord(pathPoints[pathPoints?.length - 1]?.coords)
    ) {
      if (!isPlaying && currentIndex == pathPoints?.length - 1) {
        // Adding Destination
        const popupstr = returnPopups({
          loc_type: "Destination",
          Address: shipmentData?.destinationLocation?.address,
          locationName: shipmentData?.destinationLocation?.name,
        });
        const indicatorStr = `<div class="shipment-map-indicator-container">
                             <img src="/assets/destination-location.svg" style="width:35px; height:35px; position: absolute; top: -20px; left: -7px; z-index:999" alt="Start Marker"/>
                             <img src="/assets/map-Indicators.svg" style="width:20px; height:20px" alt="Start Marker"/>
                           </div>`;
        const { indicator: indicatorReturned } = popUpAndIndicator(
          destinationCoordinates,
          popupstr,
          indicatorStr,
          map?.current,
          "left"
        );
        if (shipmentData?.shipmentstate?.toLowerCase() == "completed") {
          map.current.on("style.load", () => {
            addAccuracyCircle(
              destinationCoordinates,
              shipmentData?.destinationLocation?.radius,
              map?.current,
              bounds
            );
          });
        }
        setDestIndicatorReturned(indicatorReturned);
      }

      if (
        !isPlaying &&
        currentIndex == pathPoints?.length - 1 &&
        shipmentData?.shipmentstate?.toLowerCase() != "completed"
      ) {
        // Adding Dotted line
        if (map.current?.getLayer("dotted-line-layerl")) {
          map.current.removeLayer("dotted-line-layerl");
        }
        if (map.current?.getSource("dotted-line-sourcel")) {
          map.current.removeSource("dotted-line-sourcel");
        }
        map.current.addSource("dotted-line-sourcel", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: [
                    pathPoints[pathPoints?.length - 1]?.coords,
                    destinationCoordinates,
                  ], // single vector array
                },
                properties: {},
              },
            ],
          },
        });
        map.current.addLayer({
          id: "dotted-line-layerl",
          type: "line",
          source: "dotted-line-sourcel",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#000000",
            "line-width": 2,
            "line-dasharray": [1, 2],
          },
        });
      } else {
        if (map.current?.getLayer("dotted-line-layerl")) {
          map.current.removeLayer("dotted-line-layerl");
        }
        if (map.current?.getSource("dotted-line-sourcel")) {
          map.current.removeSource("dotted-line-sourcel");
        }

        if (destIndicatorReturned) {
          destIndicatorReturned.remove();
        }
      }
    } else {
      console.log("No valid coordinates for destination location");
    }
  }, [shipmentData, currentIndex, isPlaying, addressCurrentLoc]);

  useEffect(() => {
    if (shipmentData && correctShipmentLoaded.current) {
      return;
    }

    const shipmentIdToUse = location.state?.shipmentData?.shipmentid || id;

    if (shipmentIdToUse) {
      dispatch(
        fetchRequest({
          ...filters,
          status: [
            { text: "New", value: true },
            { text: "Acknowledged", value: false },
            { text: "Resolved", value: false },
            { text: "Auto Resolved", value: false },
          ],
          shipmentid: shipmentIdToUse,
        })
      );
      setShipmentid(shipmentIdToUse);
      fetchCompleteShipmentData(shipmentIdToUse);
    } else {
      console.error("No shipment ID available");
    }
  }, [location, id]);
  useEffect(() => {
    dispatch(fetchDeviceRequest());
    dispatch(fetchDeviceNameRequest());
  }, [dispatch]);
  useEffect(() => {
    if (hasActiveShipments1?.proceed === true && hasActiveShipments1?.id === hasActiveShipments?.shipValidate?.id) {
      handleEditProfile(hasActiveShipments?.shipValidate?.id);
      dispatch(updateshipUI({
        key: "shipValidate",
        value: { id: null, proceed: false }
      }));
    }
  }, [hasActiveShipments1?.proceed]);

  async function fetchCompleteShipmentData(shipmentIdToMatch = null) {
    try {
      if (!shipmentIdToMatch) {
        console.error("No shipment ID provided");
        return;
      }

      const response = await fetch(fetchShipment(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify({
          accountName: sessionStorage.getItem("accountId"),
          filter: {
            shipmentid: shipmentIdToMatch,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data?.pagination?.shipments?.length > 0) {
        const selectedShipment = data.pagination.shipments[0]; // Assuming the API returns the matched shipment

        if (selectedShipment) {
          // Process and set the shipment data
          const originLocation =
            selectedShipment.deviceprofile?.locations?.find(
              (loc) => loc?.locationtype === "Origin"
            );
          const destinationLocation =
            selectedShipment.deviceprofile?.locations?.find(
              (loc) => loc?.locationtype === "Destination"
            );
          const intermediateLocations =
            selectedShipment.deviceprofile?.locations?.filter(
              (loc) =>
                !loc?.locationtype?.includes("Destination") &&
                !loc?.locationtype?.includes("Origin")
            );

          setIntermediateLocations(intermediateLocations);
          setShipmentData({
            ...selectedShipment,
            devicetype: selectedShipment.devicetype,
            oncompletion: selectedShipment.oncompletion,
            shipmentName: selectedShipment.shipmentname,
            deviceid: selectedShipment.deviceid,
            origin: originLocation?.name || "N/A",
            destination: destinationLocation?.name || "N/A",
            originLocation,
            destinationLocation,
            intermediateLocations: intermediateLocations,
            startDateOriginal: selectedShipment?.startdate,
          });
          setCurrentCoordinates([
            originLocation?.longitude,
            originLocation?.latitude,
          ]);
          correctShipmentLoaded.current = true;
          viewShipmentLoaded.current = true;
        }
      } else {
        navigate("/shipments");
        console.error("No shipment found with the provided ID");
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  }

  const onExit = () => {
    dispatch(
      updateUI({
        key: "delete",
        value: {
          singleDelete: !singleDeleteShipConfirmed,
          deletedField: {
            id: "",
            name: "",
          },
        },
      })
    );
  };

  const onConfirm = () => {
    dispatch(
      singleDeleteRequest({
        singleDelete: false,
      })
    );
    navigate("/shipments");
  };

  const handleTabChange = (selectedKey) => {
    setActiveTab(selectedKey);
    dispatch(setActiveTabGlobal({ activeTabGlobal: selectedKey }));
  };

  const handleFullScreen = () => {
    if (document.fullscreenElement) document.exitFullscreen();
    else fullScreenContainer.current.requestFullscreen();
  };

  const handleBackLocationButtonClick = () => { 
      dispatch(
        updateLocationUI({
          key: "form",
          state: {
            ...locationForm,
            type: "",
            single: {
              id: null,
              name: "",
            },
            fields: {
              errors: {},
              pointName: "",
              address: "",
              latitude: "",
              longitude: "",
              radius: 500,
              isAdjustGeofanceOnMap: false,
            },
          },
        })
      );
      dispatch(
        updateDeviceProfileUI({
          key: "form",
          value: {
            ...form,
            isOpen: true,
            fields: {
              ...formFields,
              step3: {
                ...formFields.step3,
                locations: formFields.step3.locations.map((location, index) => {
                  if (location?.currentLocation === "new") {
                    const requireFields = [
                      "pointName",
                      "address",
                      "latitude",
                      "longitude",
                    ];
                    const hasValue = Object.entries(location?.new)
                      .filter((loc) => requireFields.includes(loc[0]))
                      .some((loc) => loc[1].value);
                    return {
                      ...formFields.step3.locations[index],
                      currentLocation: hasValue ? "existing" : "",
                    };
                  }
  
                  return location;
                }),
              },
            },
          },
        })
      );
    };
    const handleEditProfile = (id) => {
        const singleDeviceProfile = getSingleDeviceProfile(deviceProfiles, id, deviceTypes);    
        if (singleDeviceProfile === null) return;
        dispatch(fetchLocationRequest(-1));
        dispatch(fetchDeviceTypeRequest());
        dispatch(
          updateshipUI({
            key: "form",
            value: {
              ...forms,
              isOpen: true,
              type: "edit",
              step: 1,
              ...singleDeviceProfile,
              single: {
                ...singleDeviceProfile.single,
               // name,
                id,
              },
              fields: {
                ...singleDeviceProfile.fields
              },
            },
          })
        );
      };

    const handleShipProfileOnExitOrClose = () => {
      dispatch(updateshipUI({
          key: "activeShipmentPopup",
          value: {
            isOpen: false,
            type: "",
          }
        }));
      };

      const handleShipProfileOnConfirm = () => {
          const id = hasActiveShipments?.shipValidate?.id;
          dispatch(updateshipUI({
          key: "activeShipmentPopup",
          value: { isOpen: false, type: "" }
        }));
        dispatch(updateshipUI({
            key: "shipValidate",
            value: {
              id,
              actionType: "edit",
              proceed: true
            }
          }));
      };
  return (
    <div className="main-container">
      <div className="shipment-left">
        <Link to={"/shipments"} className="shipment-text-link">
          Shipments
        </Link>{" "}
        / <span className="font-face-vzw">Shipment details</span>
      </div>
      {showNotification && <ToastNotification {...notificationProps} />}
      {isEditShipmentOpen === true && (
        <EditShipment visible={isEditShipmentOpen} />
      )}
      {isCloneOpen === true ? <CloneShipment visible={isCloneOpen} /> : ""}
      <UpdateStateShipment />
      <DeleteShipmentModal
        showDeleteship={singleDeleteShipConfirmed}
        setShowDeleteShip={setShowDeleteShip}
        message={
          <>
            <span>Are you sure you'd like to delete the Shipment </span>
            <span
              style={{
                fontWeight: "700",
                fontFamily: "VerizonNHGDSBold",
                fontSize: "16px",
              }}
            >
              {shipmentData?.shipmentname}?
            </span>
            <br />
            <span>
              Deleting this shipment, will permanently remove the data of the
              shipment.
            </span>
          </>
        }
        title={
          <span style={{ fontWeight: "700", fontSize: "36px" }}>
            Delete Shipment
          </span>
        }
        onConfirm={onConfirm}
        onExit={onExit}
      />

      <Grid2 container style={{ padding: "11px" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1
            style={{
              fontWeight: "300",
              fontSize: "32px",
              fontFamily: "VerizonNHGDS",
              color: "black",
              display: "flex",
              alignItems: "center",
              margin: 0,
              marginLeft: -12,
            }}
            className="sasp_vz-nhg-eds-font"
          >
            {/* <img
              src={LeftArrowIcon}
              alt="filter-icon"
              onClick={() => navigate("/shipments")}
              style={{ cursor: "pointer", marginRight: "10px" }}
            /> */}
            {shipmentData?.shipmentname}
          </h1>
          <div style={{ display: "flex", gap: "12px", height: 36 }}>
            {shipmentData && (
              <ShipmentDropdownSingleFields
                name={shipmentData?.shipmentname}
                id={shipmentData?.shipmentid}
                record={shipmentData}
              />
            )}
          </div>
        </div>
      </Grid2>

      <Nav
        className="custom-right-tab1"
        variant="tabs"
        style={{ backgroundColor: "#f6f6f6", borderBottom: "none" }}
        defaultActiveKey="map"
        activeKey={activeTab}
        onSelect={handleTabChange}
      >
        <Nav.Item>
          <Nav.Link
            eventKey="map"
            as={Link}
            to="#"
            className="tab-link"
            style={{
              backgroundColor: "#f6f6f6",
              color: "#000000",
              borderBottom: activeTab !== "map" && "1px solid #cbc9c9 ",
              height: 48,
            }}
          >
            <span
              style={{
                backgroundColor: "#f6f6f6",
                fontSize: "16px",
                color: activeTab === "map" ? "#000000" : "#6F7171",
                fontFamily: "VerizonNHGDSBold",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                fontWeight: "700",
                marginLeft: "-8px",
              }}
            >
              Map view
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            eventKey="dashboard"
            as={Link}
            to="#"
            className="tab-link"
            style={{
              backgroundColor: "#f6f6f6",
              color: "#000000",
              borderBottom: activeTab !== "dashboard" && "1px solid #cbc9c9 ",
              height: 48,
            }}
          >
            <span
              style={{
                backgroundColor: "#f6f6f6",
                fontSize: "16px",
                color: activeTab === "dashboard" ? "#000000" : "#6F7171",
                fontFamily: "VerizonNHGDSBold",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                fontWeight: "700",
              }}
            >
              Alerts
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            eventKey="Shipment Data"
            as={Link}
            to="#"
            className="tab-link"
            style={{
              backgroundColor: "#f6f6f6",
              color: "#000000",
              borderBottom:
                activeTab !== "Shipment Data" && "1px solid #cbc9c9",
              height: 48,
            }}
          >
            <span
              style={{
                backgroundColor: "#f6f6f6",
                fontSize: "16px",
                color: activeTab === "Shipment Data" ? "#000000" : "#6F7171",
                fontFamily: "VerizonNHGDSBold",
                lineHeight: "20px",
                letterSpacing: "0.5px",
                fontWeight: "700",
              }}
            >
              Shipment Data
            </span>
          </Nav.Link>
        </Nav.Item>
      </Nav>
      <div style={{ marginBottom: "20px" }}></div>
      <Grid2 container>
        {activeTab === "map" && (
          <>
            <Grid2
              item
              xs={12}
              style={{
                padding: "1%",
                backgroundColor: "#fff",
                borderRadius: "12px",
              }}
            >
              <ShipmentFields shipmentData={shipmentData} />
            </Grid2>
            <div style={{ width: "100%" }}>
              <ShipmentPopup
                currentIndx={currentIndex}
                setActiveTab={setActiveTab}
              />
            </div>

            <Grid2
              item
              xs={12}
              style={{
                padding: "1%",
                backgroundColor: "#fff",
                height: "calc(110vh - 500px)",
                borderRadius: "12px",
              }}
            >
              <div
                ref={fullScreenContainer}
                style={{ position: "relative", height: "100%" }}
              >
                <div className="shipment-map-fullscreen">
                  <IconButton onClick={handleFullScreen}>
                    <OpenInFullIcon size="small" />
                  </IconButton>
                </div>
                <div
                  className="shipmentViewMap"
                  ref={mapContainer}
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  {isLoading && (
                    <Flex
                      align="center"
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                        display: "block",
                      }}
                      gap="middle"
                    >
                      {" "}
                      <Spin style={{ top: "46%", left: "48%" }} size="large" />
                    </Flex>
                  )}
                </div>
                <div className="popup-container shipmentMapPopup">
                  {pathPoints !== null ? (
                    <div className="popup-controls">
                      <button className="btn" onClick={handleBackwardClick}>
                        <i className="bi bi-skip-start-circle large-icon-play"></i>
                      </button>
                      <button
                        className="btn"
                        onClick={() => {
                          if (pathPoints?.length === 0) return;
                          setIsPlaying(!isPlaying);
                          handleStartClick(!isPlaying);
                        }}
                      >
                        <i
                          className={`bi ${
                            !isPlaying ? "bi-play-circle" : "bi-stop-circle"
                          } large-icon-play`}
                        ></i>
                      </button>
                      <button className="btn" onClick={handleForwardClick}>
                        <i className="bi bi-skip-end-circle large-icon-play"></i>
                      </button>

                      <div className="slider-container">
                        <input
                          type="range"
                          min="0"
                          max={pointsNo}
                          value={currentIndex}
                          onChange={handleRangeChange}
                          className="slider"
                        />
                        <span className="timestamp">
                          {currentIndex === 0
                            ? pathPoints?.length > 0
                              ? dayjs(pathPoints[0]?.timestamp).format(
                                  "DD MMM YYYY HH:mm:ss"
                                )
                              : dayjs(shipmentData?.updatedat).format(
                                  "DD MMM YYYY HH:mm:ss"
                                )
                            : dayjs(latlongVal?.datatimestamp).format(
                                "DD MMM YYYY HH:mm:ss"
                              )}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <Flex
                      align="center"
                      style={{ width: "100%", height: "100%" }}
                      gap="middle"
                    >
                      <Spin style={{ top: "46%", left: "48%" }} size="small" />
                    </Flex>
                  )}
                </div>
              </div>
            </Grid2>
          </>
        )}
        {activeTab === "dashboard" && (
          <Grid2 item md={12} xs={12} sm={12}>
            <AlertsContent
              shipmentid={shipmentid}
              shipmentData={shipmentData}
              setActiveTab={setActiveTab}
            />
          </Grid2>
        )}
        <CancelStateShipment />
        {activeTab === "Shipment Data" && (
          <Grid2 item md={12} xs={12} sm={12}>
            <ShipmentData
              deviceid={shipmentData?.deviceid}
              shipmentData={shipmentData}
              gateway={shipmentData?.enableble === "yes" ? false : true}
            />
          </Grid2>
        )}
      </Grid2>
      <CreateDeviceProfile />
      <ValidateDeviceProfileModal
        modalKey={"deleteprofile"}
        popupName={""}
        customClass={"deleteAlertGroup"}
        popupTitle={"Edit Device Profile"}
        open={hasActiveShipments?.shipValidate?.actionType==="edit"? hasActiveShipments?.activeShipmentPopup?.isOpen: false}
      >
        <>
          <span>Currently this device profile has one or more active shipments associated with it. </span><br/>
           <span>Are you sure you’d like to edit this profile ? </span>
          <Grid2
            container
            marginTop={2}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{
                    fontWeight: "bold",
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                  }}
                   onClick={() => handleShipProfileOnExitOrClose()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    handleShipProfileOnConfirm();
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, continue
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </ValidateDeviceProfileModal>
      <CreateNewLocation isBackButton={true} onBackClick={handleBackLocationButtonClick} />
    </div>
  );
};

export default ViewShipment;
